import React, { useEffect, useState } from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Switch,
    FormControlLabel,
} from "@mui/material";

import {
    createIncentive,
    getIncentives,
    getIncentiveSlabs,
    createIncentiveSlab
} from "../../../Servicefile/incentiveService";
import "./IncentivesPage.css";
const IncentivesPage = () => {

    const [data, setData] = useState([]);

    const [open, setOpen] = useState(false);
    const [openSlabDialog, setOpenSlabDialog] = useState(false);

    const [selectedIncentiveId, setSelectedIncentiveId] = useState("");

    const [slabs, setSlabs] = useState([]);

    const [slabForm, setSlabForm] = useState({
        orderCount: "",
        rewardAmount: ""
    });
    const [formData, setFormData] = useState({
        id: "",
        incentiveName: "",
        incentiveType: "DAILY",
        enabled: true,
        startDate: "",
        endDate: "",
    });

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const incentives = await getIncentives();

            const updatedData = await Promise.all(
                incentives.map(async (item) => {
                    try {
                        const slabs = await getIncentiveSlabs(item.id);

                        return {
                            ...item,
                            orderCount: slabs?.length > 0 ? slabs[0].orderCount : "-",
                            rewardAmount: slabs?.length > 0 ? slabs[0].rewardAmount : "-"
                        };
                    } catch (err) {
                        return {
                            ...item,
                            orderCount: "-",
                            rewardAmount: "-"
                        };
                    }
                })
            );

            setData(updatedData);

        } catch (err) {
            //console.log(err);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const openSlabPopup = async (id) => {

        try {

            setSelectedIncentiveId(id);

            const response = await getIncentiveSlabs(id);

            setSlabs(response);

            setOpenSlabDialog(true);

        } catch (err) {
            //console.log(err);
        }

    };
    const saveSlab = async () => {
        try {

            const payload = {
                incentiveId: selectedIncentiveId,
                orderCount: Number(slabForm.orderCount),
                rewardAmount: Number(slabForm.rewardAmount),
            };

            //console.log(payload);

            await createIncentiveSlab(payload);

            setSlabForm({
                orderCount: "",
                rewardAmount: "",
            });

            setOpenSlabDialog(false);

        } catch (err) {
            //console.log(err);
        }
    };
    const saveIncentive = async () => {
        try {
            const payload = {
                incentiveName: formData.incentiveName,
                incentiveType: formData.incentiveType,
                enabled: formData.enabled,
                startDate: new Date(formData.startDate).toISOString(),
                endDate: new Date(formData.endDate).toISOString(),
            };



            const response = await createIncentive(payload);


            setOpen(false);

            await loadData();

            setFormData({
                incentiveName: "",
                incentiveType: "DAILY",
                enabled: true,
                startDate: "",
                endDate: "",
            });

        } catch (err) {

            console.error("Axios Error:", err);

            if (err.response) {
                //console.log("Status Code:", err.response.status);

            } else if (err.request) {
                //console.log("No response received from server.");
                //console.log(err.request);
            } else {
                //console.log("Error Message:", err.message);
            }
        }
    };

    return (
        <div className="incentive-container">

            {/* Header */}
            <div className="incentive-header">

                <h2 className="incentive-title">
                    Incentive Management
                </h2>

                <Button
                    variant="contained"
                    className="add-btn"
                    onClick={() => setOpen(true)}
                >
                    + Add Incentive
                </Button>

            </div>

            {/* Table */}
            <div className="table-card">

                <table className="incentive-table">

                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Incentive Name</th>
                            <th>Incentive Type</th>
                            <th>Status</th>
                            <th>Order Count</th>
                            <th>Reward Amount</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>

                        {data?.length > 0 ? (

                            data.map((item) => (

                                <tr key={item.id}>

                                    <td>{item.id}</td>

                                    <td>{item.incentiveName}</td>

                                    <td>{item.incentiveType}</td>

                                    <td>
                                        <span
                                            className={
                                                item.enabled
                                                    ? "status-active"
                                                    : "status-inactive"
                                            }
                                        >
                                            {item.enabled ? "Active" : "Inactive"}
                                        </span>
                                    </td>
                                    <td>
                                        {item.orderCount}
                                    </td>

                                    <td
                                        style={{
                                            fontWeight: 600,
                                            color: "#2e7d32"
                                        }}
                                    >
                                        ₹ {item.rewardAmount}
                                    </td>
                                    <td>
                                        {item.startDate ? (
                                            <>
                                                <div>
                                                    {new Date(item.startDate).toLocaleDateString("en-GB").replace(/\//g, "-")}
                                                </div>
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#666",
                                                        marginTop: "4px"
                                                    }}
                                                >
                                                    {new Date(item.startDate).toLocaleTimeString("en-US", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                    })}
                                                </div>
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </td>

                                    <td>
                                        {item.endDate ? (
                                            <>
                                                <div>
                                                    {new Date(item.endDate).toLocaleDateString("en-GB").replace(/\//g, "-")}
                                                </div>
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#666",
                                                        marginTop: "4px"
                                                    }}
                                                >
                                                    {new Date(item.endDate).toLocaleTimeString("en-US", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                    })}
                                                </div>
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                    <td>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            sx={{
                                                background: "#1976d2",
                                                textTransform: "none",
                                                borderRadius: "8px",
                                                fontWeight: 600,
                                                "&:hover": {
                                                    background: "#1565c0"
                                                }
                                            }}
                                            onClick={() => openSlabPopup(item.id)}
                                        >
                                            View
                                        </Button>
                                    </td>
                                </tr>

                            ))

                        ) : (

                            <tr>

                                <td
                                    colSpan="6"
                                    style={{
                                        textAlign: "center",
                                        padding: "30px",
                                        color: "#777"
                                    }}
                                >
                                    No Incentives Found
                                </td>

                            </tr>

                        )}

                    </tbody>

                </table>

            </div>

            {/* Dialog */}

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="sm"
            >

                <DialogTitle className="dialog-title">
                    Add Incentive
                </DialogTitle>

                <DialogContent className="dialog-content">



                    <TextField
                        fullWidth
                        margin="normal"
                        label="Incentive Name"
                        name="incentiveName"
                        value={formData.incentiveName}
                        onChange={handleChange}
                    />

                    <FormControl
                        fullWidth
                        margin="normal"
                    >
                        <InputLabel>
                            Incentive Type
                        </InputLabel>

                        <Select
                            name="incentiveType"
                            value={formData.incentiveType}
                            label="Incentive Type"
                            onChange={handleChange}
                        >
                            <MenuItem value="DAILY">DAILY</MenuItem>

                            <MenuItem value="WEEKLY">WEEKLY</MenuItem>

                            <MenuItem value="MONTHLY">MONTHLY</MenuItem>

                            <MenuItem value="YEARLY">YEARLY</MenuItem>

                        </Select>

                    </FormControl>

                    <TextField
                        fullWidth
                        margin="normal"
                        type="datetime-local"
                        label="Start Date"
                        name="startDate"
                        value={formData.startDate}
                        onChange={handleChange}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />

                    <TextField
                        fullWidth
                        margin="normal"
                        type="datetime-local"
                        label="End Date"
                        name="endDate"
                        value={formData.endDate}
                        onChange={handleChange}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />

                    <FormControlLabel
                        sx={{ mt: 2 }}
                        control={
                            <Switch
                                checked={formData.enabled}
                                onChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        enabled: e.target.checked
                                    })
                                }
                            />
                        }
                        label="Enabled"
                    />

                </DialogContent>

                <DialogActions className="dialog-actions">

                    <Button
                        onClick={() => setOpen(false)}
                        sx={{
                            backgroundColor: "#f5f5f5",
                            color: "#555",
                            border: "1px solid #dcdcdc",
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: 600,
                            padding: "8px 22px",
                            minWidth: "110px",
                            transition: "all 0.3s ease",

                            "&:hover": {
                                backgroundColor: "#e9ecef",
                                borderColor: "#bdbdbd",
                                color: "#222",
                            },
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        className="save-btn"
                        onClick={saveIncentive}
                    >
                        Save Incentive
                    </Button>

                </DialogActions>

            </Dialog>
            <Dialog
                open={openSlabDialog}
                onClose={() => setOpenSlabDialog(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>
                    Add Incentive Slab
                </DialogTitle>

                <DialogContent>

                    <TextField
                        fullWidth
                        margin="normal"
                        type="number"
                        label="Order Count"
                        value={slabForm.orderCount}
                        onChange={(e) =>
                            setSlabForm((prev) => ({
                                ...prev,
                                orderCount: e.target.value
                            }))
                        }
                    />

                    <TextField
                        fullWidth
                        margin="normal"
                        type="number"
                        label="Reward Amount"
                        value={slabForm.rewardAmount}
                        onChange={(e) =>
                            setSlabForm((prev) => ({
                                ...prev,
                                rewardAmount: e.target.value
                            }))
                        }
                    />

                </DialogContent>

                <DialogActions>

                    <Button
                        onClick={() => setOpenSlabDialog(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={saveSlab}
                    >
                        Save
                    </Button>

                </DialogActions>

            </Dialog>
        </div>
    );
};

export default IncentivesPage;